<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <tabela :items="items" :loading="loading" @rechargeTable="getAll()" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ImportadorDadosService from '@/services/ImportadorDadosService';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    components: {
      Tabela: () => import('@/components/importadorDados/Tabela.vue')
    },

    mixins: [pusherMixins],

    data: () => ({
      items: [],
      loading: false
    }),

    mounted() {
      this.subscribe();
      this.getAll();
    },

    // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
    beforeDestroy() {
      this.pusherChannel.unbind('refresh-importador-dados');
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('refresh-importador-dados', () => {
          this.getAll();
        });
      },

      getAll() {
        this.loading = true;

        ImportadorDadosService.getAll()
          .then((response) => {
            const data = response.data.data ?? response.data.importacoes ?? response.data;
            this.items = data;
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar as importações.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
